import { CommonFunctions } from "../static/common-functions";
import { BaseInvBus } from "./BaseInvBus";
import { QILineItemBus } from "./QILineItem";

export class QuoteInvoiceBus extends QILineItemBus {
    constructor(busObj: QuoteInvoiceBus = null) {
        super(busObj);
    }
    
    CID(): any {
        return this.quoteInvoiceId;
    }
    quoteInvoiceId: any;
    quoteId: any;
    quoteInvoiceDesc: string;
}
